import {
  PlugZap, FileCheck2, Send, Inbox, FileSpreadsheet, Layers, RefreshCw, BellRing, ShieldCheck, Radio, Network, Search,
  CalendarDays, Users, Workflow, FileText, AlertTriangle, Lightbulb, Building2, Landmark, ShoppingBag, Calculator,
  Globe, Clock, Link2, Database, CheckCircle2, Receipt, Scale, ListChecks,
} from 'lucide-react';
// Icons a product config can ask for by name (config text lives in JSON-like data, so it uses names, not components).
const ICONS = {
  PlugZap, FileCheck2, Send, Inbox, FileSpreadsheet, Layers, RefreshCw, BellRing, ShieldCheck, Radio, Network, Search,
  CalendarDays, Users, Workflow, FileText, AlertTriangle, Lightbulb, Building2, Landmark, ShoppingBag, Calculator,
  Globe, Clock, Link2, Database, CheckCircle2, Receipt, Scale, ListChecks,
};
export const iconFor = (name) => ICONS[name] || FileText;
